import { ILocaleCreatorInput, TMessages } from "../i18n";
import { locale } from "./getLocale";

const globedMessages = import.meta.glob<true, string, TMessages>(
  "../../l10n/containers/*.json",
  { import: "default", eager: true }
);

function localeCreatorInput(): ILocaleCreatorInput {
  return {
    locale: locale(),
    globedMessages,
  };
}

export { localeCreatorInput };
